import { JVDropdown } from "../../../shared/JVDropdown";
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Button } from "primereact/button";
import { billiCycles } from "../../../shared/GetInvDates";

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    setNeedtoReload: (reload: boolean) => void
}
const schema = yup.object({
    prime_Vendor_Billing_Cycle: yup.string().required("Billing Cycle is required").typeError("Billing Cycle is required"),
    prime_Vendor_Payment_Term: yup.string().required("Payment Term is required").typeError("Payment Term is required"),
    timesheet_Week_Start_Day: yup.number().required("Timesheet Week Start Day is required").typeError("Timesheet Week Start Day is required"),
});

const weekDays = [
    { name: "Monday", value: 0 },
    { name: "Tuesday", value: 1 },
    { name: "Wednesday", value: 2 },
    { name: "Thursday", value: 3 },
    { name: "Friday", value: 4 },
    { name: "Saturday", value: 5 },
    { name: "Sunday", value: 6 }
];

export const ClientInformation = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors } } = useForm<IPurchaseOrder>({
        resolver: yupResolver(schema),
        defaultValues: { prime_Vendor_Billing_Cycle: props.po.prime_Vendor_Billing_Cycle, prime_Vendor_Payment_Term: props.po.prime_Vendor_Payment_Term, timesheet_Week_Start_Day: props.po.timesheet_Week_Start_Day },
        shouldFocusError: false
    });

    const saveToDB = async (body: IPurchaseOrder) => {
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        const response = await Fetch("vwPODetails/details", "POST", body, `tb=${2}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Saved Successfully" });
            props.setActiveIndex(props.activeIndex + 1);
            props.setNeedtoReload(true);
        }
        setLoading(false);
    }
    function onSubmit(data: IPurchaseOrder) {
        saveToDB(data);
    }

    return (
        <div className='w-11 m-auto mt-2'>
            <div className="grid formgrid">
                <h5 className="field col-12 md:col-4 mt-4">Company Name : <span className='text-600 font-light'>{props.po.vendor_Company_Name}</span></h5>
                <h5 className="field col-12 md:col-4">Contact Person : <span className='text-600 font-light'>{props.po.contact_Person_Name}</span></h5>
                <h5 className="field col-12 md:col-4">Email ID : <span className='text-600 font-light'>{props.po.contact_Person_EmailID}</span></h5>

                <h5 className="field col-12 md:col-4">Phone No : <span className='text-600 font-light'>{props.po.sub_Vendor_Contact_Person_Phone}</span></h5>
                <h5 className="field col-12 md:col-4">Ext No : <span className='text-600 font-light'>{props.po.sub_Vendor_Contact_Person_Ext}</span></h5>
                <h5 className="field col-12 md:col-4">Cell No : <span className='text-600 font-light'>{props.po.sub_Vendor_Contact_Person_CellNo}</span></h5>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDropdown required column={4} label="Billing Cycle" control={control} name="prime_Vendor_Billing_Cycle" options={billiCycles} optionLabel="name" optionValue="name" placeholder="Select Billing Cycle" error={errors.prime_Vendor_Billing_Cycle?.message} />
                <JVDropdown required column={4} label="Payment Term" control={control} name="prime_Vendor_Payment_Term" options={[{ name: "Net 30" }, { name: "Net 45" }, { name: "Pay on Pay" }, { name: "Net 15" }, { name: "Net 60" }, { name: "Net 7" }]} optionLabel="name" optionValue="name" placeholder="Select Payment Term" error={errors.prime_Vendor_Payment_Term?.message} />
                <JVDropdown required column={4} label="Timesheet Weekday Start Day" control={control} name="timesheet_Week_Start_Day" options={weekDays} optionLabel="name" optionValue="value" placeholder="Select Timesheet Week Start" error={errors.prime_Vendor_Billing_Cycle?.message} />
                <div className="field col-12 md:col-3">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label='SAVE & NEXT'></Button>
                </div>
            </form>
        </div>
    );
}